import style from './our-spirit-section.module.scss';
import template from '@components/careers/vacancies/vacancies.module.scss';
import Image from 'next/image';
import { IOurSpiritItem } from '@components/careers/vacancies/vacancies.interfaces';

interface IOurSpiritSectionProps {
  title: string;
  subtitle: string;
  items: IOurSpiritItem[];
}

const OurSpiritSection = ({ title, subtitle, items }: IOurSpiritSectionProps) => {
  return (
    <section className={`${template.section} ${template.section_gray}`}>
      <div className={`${template.container} ${template.container_large}`}>
        <div className={`${template.title} ${template.title_large} ${template.text_align_c} ${template.mb16}`}>
          {title}
        </div>
        <div className={`${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_c}`}>
          {subtitle}
        </div>
        <div className={`${style.items}`}>
          {items.map((item: IOurSpiritItem, index: number) => {
            return (
              <div key={index} className={`${style.items__item}`}>
                <div className={`${style.items__item__image}`}>
                  <Image sizes={'600 400 200'} src={item.imageSrc} alt={item.title} layout={'fill'} />
                </div>
                <div className={`${style.items__item__title}`}>{item.title}</div>
                <div className={`${style.items__item__text}`}>{item.text}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurSpiritSection;
